import React from "react";
import { useParams } from "react-router-dom";
import { useShopify } from "../hooks";
import { Grid } from "@material-ui/core";
import Footer from "./Footer";
import Product from "./Product";
import { Button } from "./ButtonElement";
import { Link } from "react-router-dom";
import Cart from "./Cart";
import { Carousel } from "react-responsive-carousel";
import Navbar from "./Navbar";

const Placeholder = () => {
  const getNumberOfItems = () => {
    const width = window.innerWidth;

    if (width < 960) return 1;
    if (width < 1280) return 1;
    return 1;
  };

  const numberedArray = Array.from(Array(getNumberOfItems()).keys());

  return numberedArray.map((number) => (
    <Grid item key={number}>
      <div className="loading_block" />
    </Grid>
  ));
};

const ProductLanding = (props) => {
  const { products } = useShopify();
  const banners = ["/./Assets/banner1.png", "/./Assets/banner2.png"];
  const params = useParams();

  return (
    <>
      <Navbar />
      <div>
        <div className="App__header">
          <Carousel
            autoPlay
            infiniteLoop
            interval={7000}
            showIndicators={false}
            showStatus={false}
            showThumbs={false}
            showArrows={false}
          >
            {banners.map((banner, i) => (
              <img
                key={i}
                src={banner}
                alt={`PhoenixSC Merch Store banner ${i}`}
              />
            ))}
          </Carousel>
        </div>

        <div className="App__title">
          <h1 className="App__title-text">
            The Official PhoenixSC Clothing Store
          </h1>
        </div>
        <div className="product-sort-buttons">
          <Link style={{ textDecoration: "none" }} to="/">
            <Button className="sort-buttons">View All</Button>
          </Link>
        </div>
      </div>
      <div className="Products-wrapper">
        <div className="Products-wrapper__inner" style={{ maxWidth: "500px" }}>
          {products && products.length > 0 ? (
            products
              .filter((product) => product.handle.includes(params.id))
              .map((shirt, i) => (
                <Product product={shirt} history={props.history} />
              ))
          ) : (
            <Placeholder />
          )}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ProductLanding;
